// Exit-intent feedback pop-up. Desktop only (phones have no "leaving" signal).
// Answers are posted to Formspree (URL set in snippets/exit-feedback.liquid).
(function () {
  // ---- settings ----
  const MIN_SECONDS = 25; // time on site before it can show
  const MIN_PAGES = 2; // pages viewed this visit before it can show
  const ASK_AGAIN_DAYS = 90; // do not ask the same visitor again for this long
  // ------------------

  const dialog = document.getElementById('ExitFeedback');
  if (!dialog || typeof dialog.showModal !== 'function') return;
  const endpoint = dialog.dataset.endpoint;
  if (!endpoint) return; // switched off until a Formspree URL is set
  if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

  const $ = (s) => dialog.querySelector(s);
  const step = (name) => dialog.querySelectorAll('[data-ef-step]').forEach((el) => { el.hidden = el.dataset.efStep !== name; });

  const KEY = 'th_feedback_done';
  const store = {
    get(k, s) { try { return (s ? sessionStorage : localStorage).getItem(k); } catch (e) { return null; } },
    set(k, v, s) { try { (s ? sessionStorage : localStorage).setItem(k, v); } catch (e) {} },
  };

  const lastAsked = parseInt(store.get(KEY), 10);
  if (lastAsked && Date.now() - lastAsked < ASK_AGAIN_DAYS * 86400000) return;
  if (/^\/(cart|checkouts|account|pages\/contact)/.test(location.pathname)) return;

  // count pages and time within this visit
  if (!store.get('th_fb_start', true)) store.set('th_fb_start', String(Date.now()), true);
  const pages = (parseInt(store.get('th_fb_pages', true), 10) || 0) + 1;
  store.set('th_fb_pages', String(pages), true);

  let shown = false;
  let answer = '';

  function anotherOverlayOpen() {
    return (
      document.body.classList.contains('overflow-hidden') ||
      document.querySelector('.np-modal.is-open, cart-drawer.active, dialog[open]:not(#ExitFeedback)')
    );
  }

  function canShow() {
    const seconds = (Date.now() - (parseInt(store.get('th_fb_start', true), 10) || Date.now())) / 1000;
    return !shown && seconds >= MIN_SECONDS && pages >= MIN_PAGES && !anotherOverlayOpen();
  }

  function show() {
    shown = true;
    store.set(KEY, String(Date.now()));
    step('ask');
    dialog.showModal();
  }

  // mouse leaves through the top of the window = heading for the tabs / close button
  document.addEventListener('mouseout', (e) => {
    if (!e.relatedTarget && e.clientY <= 8 && canShow()) show();
  });

  let why = '';
  const SENT_FAIL = "Sorry, that didn't send. You can reach us through our contact page instead.";

  async function send(extra) {
    const res = await fetch(endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(
        Object.assign(
          { answer, page: location.href, _gotcha: ($('[name="_gotcha"]') || {}).value || '' },
          extra
        )
      ),
    });
    if (!res.ok) throw new Error('not accepted');
  }

  const subscribeText = (on) => (on ? 'YES - please add to the email list' : 'no');
  const subj = (text, on) => `Website feedback: ${text}${on ? ' (+ SUBSCRIBE)' : ''}`;

  // pressable options: click to select, then press Submit
  function select(buttons, chosen) {
    buttons.forEach((b) => {
      const on = b === chosen;
      b.classList.toggle('is-selected', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }

  const answerBtns = [...dialog.querySelectorAll('[data-ef-answer]')];
  const whyBtns = [...dialog.querySelectorAll('[data-ef-why]')];
  const askSubmit = $('[data-ef-ask-submit]');

  dialog.addEventListener('click', async (e) => {
    if (e.target === dialog || e.target.closest('[data-ef-close]')) return dialog.close();

    const a = e.target.closest('[data-ef-answer]');
    if (a) {
      answer = a.dataset.efAnswer;
      select(answerBtns, a);
      askSubmit.textContent = answer === 'Yes' ? 'Submit' : 'Next';
      $('[data-ef-ask-error]').hidden = true;
      return;
    }

    const w = e.target.closest('[data-ef-why]');
    if (w) {
      why = w.dataset.efWhy;
      select(whyBtns, w);
      $('[data-ef-more]').hidden = why !== 'Something else';
      if (why === 'Something else') $('[data-ef-text]').focus();
      $('[data-ef-why-error]').hidden = true;
      return;
    }

    // ---- first screen: Submit / Next ----
    if (e.target.closest('[data-ef-ask-submit]')) {
      const err = $('[data-ef-ask-error]');
      const email = $('[data-ef-email]').value.trim();
      const subscribe = $('[data-ef-subscribe]').checked;
      if (!answer) {
        err.textContent = 'Choose Yes, Not quite or No first.';
        err.hidden = false;
        return;
      }
      if (subscribe && !email) {
        err.textContent = 'Add your email address to subscribe.';
        err.hidden = false;
        return;
      }
      if (answer !== 'Yes') {
        $('[data-ef-email2]').value = email;
        $('[data-ef-subscribe2]').checked = subscribe;
        return step('why');
      }
      // Yes: nothing to follow up, so only sent if they want to subscribe
      if (!subscribe) return step('thanks');
      err.hidden = true;
      askSubmit.disabled = true;
      try {
        await send({ _subject: subj('Yes (subscribe)', true), email, message: 'Found what they were looking for', subscribe: subscribeText(true) });
        step('thanks');
      } catch (e2) {
        err.textContent = SENT_FAIL;
        err.hidden = false;
        askSubmit.disabled = false;
      }
      return;
    }

    // ---- second screen: Submit ----
    if (e.target.closest('[data-ef-why-submit]')) {
      const err = $('[data-ef-why-error]');
      const email = $('[data-ef-email2]').value.trim();
      const subscribe = $('[data-ef-subscribe2]').checked;
      const text = $('[data-ef-text]').value.trim();
      if (!why) {
        err.textContent = 'Choose what got in the way first.';
        err.hidden = false;
        return;
      }
      if (subscribe && !email) {
        err.textContent = 'Add your email address to subscribe.';
        err.hidden = false;
        return;
      }
      err.hidden = true;
      const btn = $('[data-ef-why-submit]');
      btn.disabled = true;
      try {
        await send({
          _subject: subj(`${answer} - ${why}`, subscribe),
          reason: why,
          message: why === 'Something else' ? text || '(no comment)' : why,
          email: email || undefined,
          subscribe: subscribeText(subscribe),
        });
        step('thanks');
      } catch (e2) {
        err.textContent = SENT_FAIL;
        err.hidden = false;
        btn.disabled = false;
      }
    }
  });
})();
